module.exports = __webpack_public_path__ + "static/img/4-open3.27b46371.png";